export default __webpack_public_path__ + "static/media/027.2b153393.jpg";